var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"local-track-container"},[_c('video',{ref:"videoElem",attrs:{"width":"240px","autoPlay":"true","playsInline":"true","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }